export default __webpack_public_path__ + "static/media/CoreUI-Icons-Linear-Free.a141262b.svg";